// LOADING
export let LOADING = 'loading'
// WELCOME
export let WELCOME = 'welcome'
// DESTINATIONS
export let DESTINATIONS = 'destinations'
//SCENES
export let SCENES = 'scenes'
//ENDING
export let ENDING = 'ending'